// ----------------------------------------------------------------------------
// Snippet: Cart Questions
// ----------------------------------------------------------------------------
//
// "Have Questions?" support panel for the cart page
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import 'snippets/icon/icon';

// Style includes
import './_cart-questions.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CHAT_LINK_SELECTOR = 'a[href="#chat"]';
class iamCartQuestions extends HTMLElement {
  connectedCallback() {
    this.onClickRef = this.onClick.bind(this);
    this.addEventListener('click', this.onClickRef);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClickRef);
  }
  onClick(event) {
    var trigger = event.target.closest(CHAT_LINK_SELECTOR);
    if (!trigger || !this.contains(trigger)) return;
    var chat = this.getGorgiasChat();

    // No widget on the page yet: leave the link alone rather than swallow
    // the click into a dead "#chat" anchor jump.
    if (!chat) return;
    event.preventDefault();
    chat.open();
  }

  /**
   * Gorgias exposes its API under a couple of globals across embed versions.
   * Return the first that can open the widget, or null when none is ready.
   */
  getGorgiasChat() {
    var candidates = [window.GorgiasChat, window.gorgiasChat];
    return candidates.find(api => api && typeof api.open === 'function') || null;
  }
}
if (!customElements.get('iam-cart-questions')) {
  customElements.define('iam-cart-questions', iamCartQuestions);
}